module.exports = __webpack_public_path__ + "assets/media/kanishev_a.a873972b.jpg";